"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _reactBicycle = require("react-bicycle");
var _react = _interopRequireWildcard(require("react"));
var _occasion = _interopRequireDefault(require("occasion"));
var _alert = _interopRequireDefault(require("../core/alert"));
var _submit = _interopRequireDefault(require("../core/submit"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _mergeBqlQueries(firstQuery, secondQuery) { if (secondQuery === null) { return firstQuery; } const result = {}; let firstQueryUpdated = false; let secondQueryUpdated = false; for (let key in firstQuery) { if (key in firstQuery) { if (!secondQuery[key]) { firstQueryUpdated = true; result[key] = firstQuery[key]; } else if (firstQuery[key] !== secondQuery[key]) { result[key] = _mergeBqlQueries(firstQuery[key], secondQuery[key]); if (result[key] !== secondQuery[key]) { firstQueryUpdated = true; secondQueryUpdated = true; } } else { result[key] = firstQuery[key]; } } } if (!firstQueryUpdated) { return secondQuery; } for (let key in secondQuery) { if (key in secondQuery && !result[key]) { secondQueryUpdated = true; result[key] = secondQuery[key]; } } return secondQueryUpdated ? result : firstQuery; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var _ref = /*#__PURE__*/_react.default.createElement(_alert.default, {
  type: "warning"
}, "The following competitions are now full, your entries will be moved to the waiting list. You will not be charged at this time.");
class EntriesForFullCompetitions extends _react.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "state", {
      loading: false
    });
    _defineProperty(this, "_onAccept", e => {
      e.preventDefault();
      this.setState({
        loading: true
      });
      this.props.onMoveEntriesToWaitingList(this.props.entries.map(e => e.id)).then(() => this.setState({
        loading: false
      }), () => this.setState({
        loading: false
      }));
    });
  }
  render() {
    return /*#__PURE__*/_react.default.createElement("form", {
      onSubmit: this._onAccept
    }, _ref, this.props.entries.map(entry => /*#__PURE__*/_react.default.createElement("p", {
      key: entry.id
    }, entry.competition.competitionName, ": ", entry.race.raceName, " bib ", entry.startListBib, " on", ' ', (0, _occasion.default)(entry.race.competitionDay.dayDate, 'dddd'), " - ", entry.eligibilityStatus.text)), /*#__PURE__*/_react.default.createElement(_submit.default, {
      "data-test-id": "full-comp-entry-to-wait",
      loading: this.state.loading
    }, "Accept"));
  }

  // *******************************************************************************
  // PartialQuery definition
  // *******************************************************************************
}

// *******************************************************************************
// Data and actions
// *******************************************************************************
_defineProperty(EntriesForFullCompetitions, "partials", {
  Entry: {
    id: true,
    startListBib: true,
    eligibilityStatus: {
      text: true
    },
    competition: {
      competitionName: true
    },
    race: {
      raceName: true,
      competitionDay: {
        dayDate: true
      }
    }
  }
});
var _default = exports.default = (0, _reactBicycle.connect)(EntriesForFullCompetitions, null, (client, props) => ({
  onMoveEntriesToWaitingList(entryIDs) {
    return client.update('Basket.moveEntriesToWaitingList', {
      entryIDs
    });
  }
}));